import { NJButton, NJIcon, NJSegmentedControl, NJSegmentedControlButton, NJText } from '@engie-group/fluid-design-system-react';
import { HOME_SCENARIOS, isHomeScenario, SCENARIO_LABELS, type HomeScenario } from './homeScenarios';
import { useResetData } from './hooks';

export function ScenarioSwitcher({ value, onChange }: { value: HomeScenario; onChange: (value: HomeScenario) => void }) {
  const reset = useResetData();
  return (
    <aside className="pav-scenario-switcher" aria-label="Prototype — variantes d’accueil">
      <div className="pav-switcher-heading">
        <NJIcon name="science" scale="sm" />
        <NJText as="strong" scale="sm">Prototype — variantes d’accueil</NJText>
        <NJButton label="Réinitialiser les données" icon="restart_alt" variant="secondary" emphasis="minimal"
          scale="sm" disabled={reset.isPending} onClick={() => reset.mutate()} />
      </div>
      <NJSegmentedControl label="État de l’accueil" value={value} size="sm"
        onChange={(next) => { if (isHomeScenario(next)) onChange(next); }}>
        {HOME_SCENARIOS.map((scenario) => <NJSegmentedControlButton key={scenario}
          label={SCENARIO_LABELS[scenario]} value={scenario} />)}
      </NJSegmentedControl>
      <NJText scale="xs">Outil de démonstration · ne modifie pas les droits ni les données V3.</NJText>
      {reset.isError && <NJText scale="xs" role="alert">Réinitialisation impossible. Réessayez.</NJText>}
    </aside>
  );
}
